module.exports = __webpack_public_path__ + "static/stena-099a54430a3377206a16eb7b1fdc3cd1.png";